export const LIST_POSITION_PAGES = {
	account: 'account',
	insights: 'insights',
	marketplace: 'marketplace',
};
